import { StudentIpExamSettingContent } from './StudentIpExamSettingContent';
export default StudentIpExamSettingContent;